<router-outlet></router-outlet>
<aplx-core-api-loader></aplx-core-api-loader>
